import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import { AxiosResponse } from "axios"
import {
  TAuthChangePasswordPutReq,
  TAuthLoginByPassCodeReq,
  TAuthLoginByQRCodeReq,
  TAuthLoginReq,
  TAuthLoginRes,
  TAuthResetPasswordPutReq,
} from "./TAuth"

/**
 *
 * ログイン周りのservice
 * @export
 * @class AuthService
 * @extends {ConnectApi}
 */
export default class AuthService extends ConnectApi {
  /**
   * ログイン処理
   * @param data
   * @returns
   */
  login = async (data: TAuthLoginReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAuthLoginRes>> =
        await this.postInner(`/auth/login`, data)

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * ログイン処理(カードログイン)
   * @param data
   * @returns
   */
  loginByPassCode = async (data: TAuthLoginByPassCodeReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAuthLoginRes>> =
        await this.postInner(`/auth/login/actions/passcode`, data)

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * ログイン処理(QRコード)
   * @param data
   * @returns
   */
  loginByQRCode = async (data: TAuthLoginByQRCodeReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAuthLoginRes>> =
        await this.postInner(`/auth/login/actions/qrcode`, data)

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * ログイン処理(カードログイン)
   * @param data
   * @returns
   */
  tabletLoginByPassCode = async (data: TAuthLoginByPassCodeReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAuthLoginRes>> =
        await this.postInner(`/auth/login/actions/passcode/tenkosya`, data)

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * ログイン処理(QRコード)
   * @param data
   * @returns
   */
  tabletLoginByQRCode = async (data: TAuthLoginByQRCodeReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAuthLoginRes>> =
        await this.postInner(`/auth/login/actions/qrcode/tenkosya`, data)

      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * ログアウト処理
   * @returns
   */
  logout = async () => {
    try {
      const res: AxiosResponse<TApiResponse<null>> = await this.postInner(
        `/auth/logout`,
        undefined
      )
      return res.data
    } catch (error) {
      throw error
    }
  }
  /**
   * パスワード変更
   * @param data
   * @returns
   */
  changePassword = async (data: TAuthChangePasswordPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/auth/changepassword`,
        data
      )
      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * パスワードリセット
   * @param data
   * @returns
   */
  resetPassword = async (data: TAuthResetPasswordPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/auth/resetpassword`,
        data
      )
      return res.data
    } catch (error) {
      throw error
    }
  }
  /**
   * ログインテスト
   */
  test = async () => {
    try {
      const res: AxiosResponse<TApiResponse<string>> = await this.getInner(
        `/auth/Test`
      )
      return res.data
    } catch (error) {
      throw error
    }
  }
}
